type SVGProps = {
  width: string | number;
  height: string | number;
};

const TieringCup = ({ width = 32, height = 34 }: SVGProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
  >
    <defs>
      <path
        id='a'
        d='M27 1v11c0 2.955-1.174 5.728-3.223 7.777A10.967 10.967 0 0 1 16 23C9.928 23 5 18.072 5 12V1a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1z'
      />
      <filter
        id='b'
        width='118.2%'
        height='117.4%'
        x='-9.1%'
        y='-8.7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset
          dx='-4'
          dy='-2'
          in='SourceAlpha'
          result='shadowOffsetInner1'
        />
        <feComposite
          in='shadowOffsetInner1'
          in2='SourceAlpha'
          k2='-1'
          k3='1'
          operator='arithmetic'
          result='shadowInnerInner1'
        />
        <feColorMatrix
          in='shadowInnerInner1'
          values='0 0 0 0 0.815686275 0 0 0 0 0.48627451 0 0 0 0 0.207843137 0 0 0 0.5 0'
        />
      </filter>
      <path
        id='c'
        d='M14 30a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-4zm-8 4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6z'
      />
      <filter
        id='d'
        width='118.2%'
        height='130.8%'
        x='-9.1%'
        y='-15.4%'
        filterUnits='objectBoundingBox'
      >
        <feOffset
          dx='-4'
          dy='-2'
          in='SourceAlpha'
          result='shadowOffsetInner1'
        />
        <feComposite
          in='shadowOffsetInner1'
          in2='SourceAlpha'
          k2='-1'
          k3='1'
          operator='arithmetic'
          result='shadowInnerInner1'
        />
        <feColorMatrix
          in='shadowInnerInner1'
          values='0 0 0 0 0.815686275 0 0 0 0 0.48627451 0 0 0 0 0.207843137 0 0 0 0.5 0'
        />
      </filter>
      <path
        id='e'
        d='M25 13V5a1 1 0 0 1 1-1h4a2 2 0 0 1 2 2v2a6 6 0 0 1-6 6 1 1 0 0 1-1-1zM7 13a1 1 0 0 1-1 1 6 6 0 0 1-6-6V6a2 2 0 0 1 2-2h4a1 1 0 0 1 1 1v8z'
      />
      <filter
        id='f'
        width='112.5%'
        height='140%'
        x='-6.2%'
        y='-20%'
        filterUnits='objectBoundingBox'
      >
        <feOffset
          dx='-4'
          dy='-2'
          in='SourceAlpha'
          result='shadowOffsetInner1'
        />
        <feComposite
          in='shadowOffsetInner1'
          in2='SourceAlpha'
          k2='-1'
          k3='1'
          operator='arithmetic'
          result='shadowInnerInner1'
        />
        <feColorMatrix
          in='shadowInnerInner1'
          values='0 0 0 0 0.815686275 0 0 0 0 0.48627451 0 0 0 0 0.207843137 0 0 0 0.5 0'
        />
      </filter>
      <linearGradient id='g' x1='0%' x2='90.621%' y1='100%' y2='9.379%'>
        <stop offset='0%' stopColor='#8A4C23' />
        <stop offset='100%' stopColor='#D07C35' />
      </linearGradient>
    </defs>
    <g fill='none'>
      <use fill='#FFFDF8' fillRule='evenodd' />
      <use fill='#000' filter='url(#b)' />
      <use fill='#FFFDF8' fillRule='evenodd' />
      <use fill='#000' filter='url(#d)' />
      <g>
        <use fill='#FFFDF8' fillRule='evenodd' />
        <use fill='#000' filter='url(#f)' />
      </g>
      <path
        fill='url(#g)'
        d='M14 30a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-4zm1-2h2v-5h-2v5zm-9 6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6zm1-2h18v-2H7v2zM25 2H7v10c0 4.968 4.032 9 9 9a8.967 8.967 0 0 0 6.363-2.637A8.967 8.967 0 0 0 25 12V2zm2-1v11c0 2.955-1.174 5.728-3.223 7.777A10.967 10.967 0 0 1 16 23C9.928 23 5 18.072 5 12V1a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1zm3 7V6h-3v5.874c1.725-.444 3-2.01 3-3.874zm-5 5V5a1 1 0 0 1 1-1h4a2 2 0 0 1 2 2v2a6 6 0 0 1-6 6 1 1 0 0 1-1-1zM7 13a1 1 0 0 1-1 1 6 6 0 0 1-6-6V6a2 2 0 0 1 2-2h4a1 1 0 0 1 1 1v8zm-2-1.126V6H2v2a4.002 4.002 0 0 0 3 3.874z'
      />
    </g>
  </svg>
);

export default TieringCup;
